/**
 * Register a lightweight service worker so Chrome can offer "Add to Home Screen".
 * Production only — avoids cache pain in local npm start.
 */
import { initPatientInstallPromptCapture } from './patientInstallPrompt';

export function registerPatientServiceWorker() {
    initPatientInstallPromptCapture();

    if (typeof window === 'undefined' || !('serviceWorker' in navigator)) {
        return;
    }
    if (process.env.NODE_ENV !== 'production') {
        return;
    }
    const onLoad = () => {
        navigator.serviceWorker
            .register(`${process.env.PUBLIC_URL || ''}/sw.js`)
            .catch((err) => {
                console.warn('Live Assist SW register failed', err);
            });
    };
    if (document.readyState === 'complete') {
        onLoad();
    } else {
        window.addEventListener('load', onLoad);
    }
}
